import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
// import { css } from "@emotion/react";
// import { fontColor, FONTS, fontSize } from "../../../../../styles/fonts";
// import React from "react";

export const PDPAvailabilityNotificationBanner: ReactTFC<{
  paragraph: string;
}> = props => {
  return null;
  // return (
  //   <p
  //     css={[
  //       FONTS.SwarovskiFutura300,
  //       fontSize.x2,
  //       fontColor.black,
  //       css`
  //         margin: 0;
  //       `,
  //     ]}
  //   >
  //     {props.paragraph}
  //   </p>
  // );
};
